module.exports = __webpack_public_path__ + "img/lcd_01.579e4936.jpg";